import React, { useState } from "react";

const AddTheme = () => {
  const [themeData, setThemeData] = useState({
    theme: "",
    mode: "default",
    types: "",
  });

  const [imageFile, setImageFile] = useState(null);
  const [message, setMessage] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle text/select changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setThemeData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle image file input
  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!themeData.theme) {
      setMessage("Please enter a theme name.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("theme", themeData.theme);
      formData.append("mode", themeData.mode);
      formData.append("types", themeData.types);
      if (imageFile) formData.append("image", imageFile);

      const response = await fetch("https://api.malidag.com/themesinput", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage(`✅ Theme added successfully: ${data.theme.theme}`);
        setThemeData({ theme: "", mode: "default", types: "" });
        setImageFile(null);
        setImageUrl(data.theme.image);
      } else {
        setMessage(`❌ Error: ${data.message || "Failed to add theme."}`);
      }
    } catch (err) {
      console.error("Error:", err);
      setMessage(`❌ Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginBottom: "30px", maxWidth: "500px", margin: "0 auto" }}>
      <h2>Add a New Theme</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Theme:
          <input
            type="text"
            name="theme"
            value={themeData.theme}
            onChange={handleChange}
            required
          />
        </label>
        <br />

        <label>
          Image:
          <input type="file" accept="image/*" onChange={handleFileChange} />
        </label>
        <br />

        <label>
          Mode:
          <select name="mode" value={themeData.mode} onChange={handleChange}>
            <option value="default">Default</option>
            <option value="full">Full</option>
            <option value="large">Large</option>
            <option value="product">Product</option>
            <option value="large-circle">Large Circle</option>
            <option value="text-image">Text + Image</option>
          </select>
        </label>
        <br />

        <label>
          Types (comma-separated):
          <input
            type="text"
            name="types"
            value={themeData.types}
            onChange={handleChange}
            placeholder="Type1,Type2,Type3"
          />
        </label>
        <br />

        <button type="submit" disabled={loading}>
          {loading ? "Uploading..." : "Add Theme"}
        </button>
      </form>

      {message && (
        <p style={{ marginTop: "10px", color: message.includes("✅") ? "green" : "red" }}>
          {message}
        </p>
      )}

      {imageUrl && (
        <div style={{ marginTop: "20px" }}>
          <h4>Uploaded Image:</h4>
          <img
            src={imageUrl}
            alt="Uploaded Theme"
            style={{
              width: "300px",
              height: "auto",
              borderRadius: "10px",
              boxShadow: "0 0 5px rgba(0,0,0,0.2)",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default AddTheme;
